function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-circle-trash");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22,0A22,22,0,1,0,43.99991,22,22.02487,22.02487,0,0,0,22,0",
  fill: "#ff4000",
  opacity: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("polyline", {
  points: "15 16.556 16.556 16.556 29 16.556",
  fill: "none",
  stroke: "#ff4000",
  strokeLinecap: "square",
  strokeWidth: 1.25
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.44441,16.55558V27.44447A1.55555,1.55555,0,0,1,25.88886,29H18.11108a1.55555,1.55555,0,0,1-1.55555-1.55556V16.55558m2.33333,0V15a1.55555,1.55555,0,0,1,1.55555-1.55556h3.11112A1.55556,1.55556,0,0,1,25.11108,15v1.55555",
  fill: "none",
  stroke: "#ff4000",
  strokeLinecap: "square",
  strokeWidth: 1.25
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 20.44441,
  y1: 20.44447,
  x2: 20.44441,
  y2: 25.11114,
  fill: "none",
  stroke: "#ff4000",
  strokeLinecap: "square",
  strokeWidth: 1.25
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 23.55553,
  y1: 20.44447,
  x2: 23.55553,
  y2: 25.11114,
  fill: "none",
  stroke: "#ff4000",
  strokeLinecap: "square",
  strokeWidth: 1.25
});

const SvgCircleTrash = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f25f1276-e8ff-4e43-9b6f-15fe788321c5",
    "data-name": "Layer 1",
    viewBox: "0 0 43.99991 44.00006",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircleTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle-trash.2284da57.svg";
export { ForwardRef as ReactComponent };